import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaErrorPage, WeaLocaleProvider, WeaTools} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import Title from './Title';
import Iframe from './Iframe';
//内容组件
class EContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabdata: props.edata.data,
            currentTab: props.edata.currenttab,
            refresh: false,
        }
        this.handleTabData = this.handleTabData.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
    }
    handleRefresh(refresh){
        this.setState({
            refresh,
        });   
    }
    componentWillReceiveProps(nextProps){
        if(!isEqual(this.props.edata, nextProps.edata)){
            this.setState({
                tabdata: nextProps.edata.data,
                currentTab: nextProps.edata.currenttab,
            });
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    handleTabData(tabid){
        const { params, isremembertab } = this.props.config;
        const { currentTab } = this.state;
        this.setState({
            currentTab: tabid,
            refresh: true,
        });
        WeaTools.callApi('/api/portal/element/custompagetab', 'POST', {...params, tabid}).then(result => {
            if(tabid === this.state.currentTab){
                this.setState({
                    tabdata: result,
                    refresh: false,
                });
                window.elements_more_params[params.eid] = {moreurl: result.moreUrl};
            }
       });
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    render() {
        const { config, edata, handleRefresh, handleDelete, requestid, fontSizeMp } = this.props;
        const { tabdata, currentTab, refresh } = this.state; 
        const { tabids = [], titles = [], esetting } = edata;
        let { fontStyle } = config.item;
        if(!isEmpty(fontSizeMp)) fontStyle = fontSizeMp;
        esetting.fontStyle = fontStyle;
        const { eid } = config.params;
        const { contentview = {} } = config.item;
        const cstyle = tabids && tabids.length > 1 && contentview.style && contentview.style.height ? {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"} : {};
        let contentHtml = <div/>
        if(tabdata) {
            const { contenttype, componentName } = tabdata;
            if(contenttype == '1'){
               contentHtml = <Iframe isSetting={config.isSetting} config={config} requestid={requestid} refresh={refresh} data={tabdata} eid={eid} tabid={currentTab} cstyle={contentview.style}/>;
            } else if(contenttype == '2' && componentName){
                try {
                    const { componentModule, componentProps } = tabdata;
                    if(componentModule){
                        contentHtml = <div>{window[componentModule][componentName](componentProps)}</div>
                    }else{
                        contentHtml = <div>{window[componentName](componentProps)}</div>
                    }
                } catch(e) {
                    window.console ? console.log(getLabel(387999,"组件异常："),e) : alert(getLabel(387999,"组件异常：")+e);
                }
            }
        }
        const _titleProps = {
            currentTab,
            config,
            titles,
            tabids,
            handleRefresh,
            handleDelete,
            fontSizeMp,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            handleTabData: this.handleTabData
        }
        return <div>
            <Title {..._titleProps}/>
            <div className="tabContant" id={`tabcontant_${eid}`} style={{height: cstyle.height}}>
                <Spin spinning={refresh}>{contentHtml}</Spin>
            </div>
         </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
EContent = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EContent);
export default EContent;








// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/custompage/EContent.js